import { createFrontendModule } from "@backstage/frontend-plugin-api";
import {
    createFormField,
    FormFieldBlueprint,
} from "@backstage/plugin-scaffolder-react/alpha";

import { SpannerDomainSelectField } from "./components";

const SpannerDomainSelectExtension = FormFieldBlueprint.make({
    name: "spanner-domain-select",
    params: {
        field: async () =>
            createFormField({
                name: "SpannerDomainSelect",
                component: SpannerDomainSelectField,
            }),
    },
});

const scaffolderModuleSpannerDomainSelect = createFrontendModule({
    pluginId: "scaffolder",
    extensions: [SpannerDomainSelectExtension],
});

export default scaffolderModuleSpannerDomainSelect;
